import LandingPage from './landing-page';

const LandingPageConfig = {
  settings: {
    layout: {
      style: 'layoutFull',
      config: {}
    }
  },

  routes: [
    {
      path: '/welcome',
      component: LandingPage,
      title: 'TURP Giriş Yap',
      exact: true
    }
  ]
};

export default LandingPageConfig;
